import { Megaphone } from 'lucide-react';
import { Text } from '@music-vine/cadence/ui';
import { CustomLicensingFormTrigger } from './CustomLicensingFormTrigger';

/** Custom licensing enquiry banner + Typeform dialog (DEV-6398). */
export const CustomLicensingBanner = () => <div className="flex flex-col items-start gap-4 rounded-xl border border-blue-business-200 border-solid bg-blue-business-25 p-6 sm:flex-row sm:items-center dark:border-blue-business-925 dark:bg-blue-business-975" data-sentry-component="CustomLicensingBanner" data-sentry-source-file="CustomLicensingBanner.tsx">
    <div className="flex-1">
      <Text asChild className="mb-0.5 flex items-start gap-1 font-semibold text-base text-gray-950 sm:text-xl dark:text-white" data-sentry-element="Text" data-sentry-source-file="CustomLicensingBanner.tsx">
        <h3>
          {/* Matches FreePlanBanner — icon centres on the first line, not
                on the whole heading, so a wrap can't drift it (DEV-6728). */}
          <Megaphone className="size-6 shrink-0 sm:mt-1" data-sentry-element="Megaphone" data-sentry-source-file="CustomLicensingBanner.tsx" />
          Looking for something bigger?
        </h3>
      </Text>
      <Text className="text-pretty text-gray-700 text-sm dark:text-gray-400" data-sentry-element="Text" data-sentry-source-file="CustomLicensingBanner.tsx">
        We offer custom licensing for broadcast, paid streaming services, radio,
        cinema and more.
      </Text>
    </div>
    <CustomLicensingFormTrigger content="Talk to us" eventValue="pricing-page-main" type="button" data-sentry-element="CustomLicensingFormTrigger" data-sentry-source-file="CustomLicensingBanner.tsx" />
  </div>;